var map = {
	"./Behaviol.png": 815,
	"./BlackMirageStudio.webp": 177,
	"./Chokolaate.png": 746,
	"./Codechefs.png": 937,
	"./CynthSpace.png": 535,
	"./Divisional Federation of Youth Club Ja-Ella.png": 758,
	"./FriendlyGameDev.png": 523,
	"./GenAlpha.png": 297,
	"./GoodPR.png": 874,
	"./GoogleDevelopersGroupSriLanka.jpeg": 428,
	"./Graffon.png": 148,
	"./ISCS.png": 293,
	"./Kosolink.png": 539,
	"./LaptopLK.webp": 832,
	"./Yunash.png": 595,
	"./checkmateAlley.png": 989,
	"./fosLEO.png": 335,
	"./heladev.png": 434,
	"./lenovo.webp": 365,
	"./rakaara.png": 304,
	"./ram.png": 351,
	"./rivertune.png": 739,
	"./spaceTimer.png": 354,
	"./timelesstoucan.png": 553,
	"./yashoda.png": 208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 745;